import { omitBy, isNil } from 'lodash';

const model = (
    filters,
    // orgID,
    approvalStatus,
    tempDelete,
    onlineStatus,
    pagination,
    sorting
) => {
    return omitBy(
        {
            filters: omitBy(
                filters,
                value => isNil(value) || value === ""
            ),
            // orgID: orgID,
            approvalStatus:approvalStatus,
            tempDelete:tempDelete,
            onlineStatus:onlineStatus,
            pagination:pagination,
            sorting:sorting,
        },
        isNil
    )
}

export default model;